<template>
<div class="head-search">
    <form action="/catalog/" method="get" >
        <div class="search">
            <input v-model="q" autocomplete="off" name="q" type="search" placeholder="Поиск"/>
            <input type="submit" value="Найти"/>
        </div>
    </form>
</div>
</template>

<script>
export default {
    name : 'HeaderSearch',
    props : {
        value : {
            type : String,
            default : '',
        },
    },
    data : () => ({
        q : '',
    }),
    mounted () {
        this.q = this.value;
    },
}
</script>
